
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strefa-wiedzy",
      function () {
        return require("private-next-pages/strefa-wiedzy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strefa-wiedzy"])
      });
    }
  